<div class="dialog-header">
  <div class="dialog-title">
    <div style="display: flex; align-items: center;">
      <mat-icon class="dialog-icon">check_circle</mat-icon>
      {{data.aufgabe.AufgabeString}}
    </div>
  </div>
  <button mat-icon-button class="close-button" [mat-dialog-close]="false">
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>

<mat-divider></mat-divider>

<div mat-dialog-content>
  <div [innerHTML]="this.oroservice.getCaption(data.aufgabe.Texte)"></div>

  <!-- LI Vollmacht oder LI Vollmacht Erinnerung-->
  @if (this.data.aufgabe?.Art == 46 || this.data.aufgabe?.Art == 47) {
    <div>
      {{'Rückfragen.VollmachtAufgabeInfo' | translate}}
      <BR><BR>
      @if (this.data.aufgabe.DokumentId > 0) {
        <div>
          @if (this.data.aufgabe.DokumentId > 0) {
            <button color="primary" mat-button matSuffix class="button-dialog"
              (click)="this.oroservice.downloadDocument(this.data.aufgabe.DokumentId, 'Vollmacht.pdf')" style="margin:0px">
              <mat-icon>file_download</mat-icon>{{'Rückfragen.Vollmacht' | translate}}
            </button>
          }
        </div>
      }
      <div class="row no-padding">
        <div class="rmpm dropzone" style="width:260px" appDragDrop (files)="fileservice.filesDropped($event)">
          <div class="text-wrapper">
            <div class="centered">
              <mat-icon style="font-size: 64px; width:64px; height: 64px; opacity: 0.2;">publish</mat-icon>
              <BR>
              {{'DragVollmacht' | translate}}
            </div>
          </div>
        </div>
        <div class="col">
          <button mat-button matSuffix class="button-dialog" (click)="fileMultiInput.click()">
            <mat-icon>attach_file</mat-icon> {{'Dateiauswaehlen' | translate}}
          </button>
          @if (this.fileservice.files.length > 3) {
            <button mat-button matSuffix class="button-dialog"
              (click)="fileservice.removeAllFiles()">
              <mat-icon>delete</mat-icon> {{'Alle löschen' | translate}}
            </button>
          }
          <input hidden (change)="fileservice.handleMultiFileInput($event.target.files)" #fileMultiInput
            type="file" accept=".pdf,.jpg,.jpeg" id="file" multiple>
            <div class="row no-padding">
              <mat-list>
                @for (file of fileservice.files; track file) {
                  <mat-list-item style="height:36px; font-size: 14px;">
                    <mat-icon>picture_as_pdf</mat-icon>&nbsp;
                    {{fileservice.getFileInfo(file)}}&nbsp;
                    <button mat-icon-button color="accent" matSuffix (click)="fileservice.removeFile(file)"
                      style="margin:0px">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </mat-list-item>
                }
              </mat-list>
            </div>
            @if (fileservice.isFileTooBig) {
              <div class="row no-padding">
                <mat-error>{{'ErrorSizeFormat' | translate}}</mat-error>
              </div>
            }
          </div>
        </div>
        <button mat-flat-button color="primary" class="button-dialog" (click)="submit()"
          [disabled]="!this.canSubmit()" style="margin-top: 8px;">
          <mat-icon>reply</mat-icon>&nbsp;{{'Rückfragen.Antworten' | translate}}
        </button>
        <BR><BR>
      </div>
    }

    <mat-checkbox color="primary" [(ngModel)]="this.data.aufgabe.Erledigt">{{'Startseite.AufgabeErledigt' | translate}}
    </mat-checkbox>
  </div>

  <!-- <div mat-dialog-actions>
  <button mat-flat-button color="primary" class="button-dialog"
  [mat-dialog-close]=false>{{'schliessen' | translate}}</button>
</div> -->
